import React from "react";
import { t } from "@auto/services";

import { VIEW_ADMINISTRATIVE, VIEW_CONSTITUENCY } from "../constants";
import * as api from "../api";
import {
  clearSelectionBelowRoot,
  setError,
  setLoading,
  setRootLists,
  setViewMode,
} from "../state";
import { useObservable } from "../hooks";

import AdministrativeTree from "./AdministrativeTree";
import ConstituencyTree from "./ConstituencyTree";

import styles from "../../ElectoralGeographyPage.module.styl";

const GeographyTree = ({ gui, state, setState, events }) => {
  const loadRootLists = React.useCallback(async () => {
    setLoading(setState, true);
    setError(setState, "");

    try {
      const roots = await api.loadRoots();
      setRootLists(setState, roots);
    } catch (err) {
      setError(setState, err?.message || String(err));
    } finally {
      setLoading(setState, false);
    }
  }, [setState]);

  React.useEffect(() => {
    loadRootLists();
  }, [loadRootLists]);

  const handleViewChanged = React.useCallback((nextMode) => {
    if (state.viewMode === nextMode) {
      return;
    }

    setViewMode(setState, nextMode);
    clearSelectionBelowRoot(setState);
  }, [setState, state.viewMode]);

  const handleEntitySaved = React.useCallback(async ({ entity }) => {
    if (entity === "department" || entity === "constituency") {
      await loadRootLists();
    }
  }, [loadRootLists]);

  useObservable(events.viewChanged, handleViewChanged);
  useObservable(events.entitySaved, handleEntitySaved);
  useObservable(events.entityDeleted, handleEntitySaved);

  return (
    <section className={styles.treePanel}>
      <div className={styles.viewToggle}>
        <button
          type="button"
          className={state.viewMode === VIEW_ADMINISTRATIVE ? styles.activeViewButton : ""}
          onClick={() => events.viewChanged.publish(VIEW_ADMINISTRATIVE)}
        >
          {t("person.department")}
        </button>

        <button
          type="button"
          className={state.viewMode === VIEW_CONSTITUENCY ? styles.activeViewButton : ""}
          onClick={() => events.viewChanged.publish(VIEW_CONSTITUENCY)}
        >
          {t("geo.constituency")}
        </button>
      </div>

      <div className={styles.tree}>
        {state.viewMode === VIEW_ADMINISTRATIVE ? (
          <AdministrativeTree gui={gui} state={state} setState={setState} events={events} />
        ) : (
          <ConstituencyTree gui={gui} state={state} setState={setState} events={events} />
        )}
      </div>
    </section>
  );
};

export default GeographyTree;
